import React from 'react';
import { Link } from 'react-router-dom';
import SideBar  from '../../components/Topbar';
import { HTMLCourseNavProvider } from "../../components/SidebarCourseContext";
import PhpProgramminglanguage from './assets/images/php-programming-language.png';

const PhpLesson1 = () => {
  return(
    <HTMLCourseNavProvider>
    <div className="container">
    <div className="row">
    <div>
    <SideBar  />
    </div>
    <div className="col-md-12">


    <div className="alert alert-secondary" role="alert">
    <h3><strong>A Brief History of PHP</strong></h3>
   <p>Formerly known as <b>Personal Home Page</b>, and now known as <b>HyperText Preprocessor</b>, PHP was first developed in 1994 by <b>Rasmus Lerdorf.</b></p>
   <p>At first, non-released versions were used on his home page to keep track of who was looking at his online resume. But it was not until early 1995 that the first version became available to the public.</p>
   <p>The first version comprised a simplistic parser engine that only understood a few special macros and a number of utilities that were in common use on home pages back then.</p>
   <p>At the turn of  mid-1995, this parser would be
   rewritten and became known as <b>PHP/FI Version 2</b>. With support for <b>mSQL</b> added, people began contributing code to it, and by late 1996, there were already <b>15,000</b> websites running on PHP.</p>
    <p>Today, PHP powers about <b>77.7%</b> of all websites on the internet. Infact, it powers the world's biggest blogging system <b>WordPress!</b>, was used to build <b>Facebook</b>, and is easy to get started with.</p>
    </div>
    <div className="alert alert-secondary" role="alert">
    <h3><strong>What Can PHP Really Do?</strong></h3>
    <ol class="list-group list-group-numbered mb-4">
  <li class="list-group-item">PHP can generate dynamic page content.</li>
  <li class="list-group-item">PHP can create, open, read, write, delete, and close files on the server.</li>
  <li class="list-group-item">PHP can collect form data.</li>
  <li class="list-group-item">PHP can send and receive cookies.</li>
  <li class="list-group-item">PHP can add, delete, modify data in your database.</li>
  <li class="list-group-item">PHP can be used to control user-access</li>
  <li class="list-group-item">PHP can encrypt data</li>
  </ol>
  </div>
  <div className="alert alert-secondary" role="alert">
  <h3><strong>So Why PHP?</strong></h3>
  <ol class="list-group list-group-numbered mb-4">
  <li class="list-group-item">PHP runs on various platforms (Windows, Linux, Unix, Mac OS X, etc.).</li>
  <li class="list-group-item">PHP is compatible with almost all servers used today (Apache, IIS, etc.).</li>
  <li class="list-group-item">PHP supports a wide range of databases.</li>
  <li class="list-group-item">PHP is free. Download it from the official PHP resource: www.php.net</li>
  <li class="list-group-item">PHP is easy to learn and runs efficiently on the server side.</li>
  </ol>
  <p>In the next lesson, we shall look at how to install PHP.</p>
  </div>

  </div>
  </div>
  </div>
  </HTMLCourseNavProvider>
  )
}
export default PhpLesson1
